var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBulletListItem = function SvgBulletListItem(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.0394C6 15.8299 7.23344 16.5262 8.74539 15.5713L13.3409 12.7065C14.8728 11.7715 14.8728 10.2197 13.3409 9.28471L8.74539 6.41995C7.23344 5.48493 6 6.16133 6 7.9518V14.0394Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBulletListItem);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMTQuMDM5NEM2IDE1LjgyOTkgNy4yMzM0NCAxNi41MjYyIDguNzQ1MzkgMTUuNTcxM0wxMy4zNDA5IDEyLjcwNjVDMTQuODcyOCAxMS43NzE1IDE0Ljg3MjggMTAuMjE5NyAxMy4zNDA5IDkuMjg0NzFMOC43NDUzOSA2LjQxOTk1QzcuMjMzNDQgNS40ODQ5MyA2IDYuMTYxMzMgNiA3Ljk1MThWMTQuMDM5NFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";